@if (footerDisclaimerComponent) {
  <dotcom-frontend-loader [componentData]="footerDisclaimerComponent" />
}
<div lgContainer>
  <div class="footer" lgRow>
    <div [lgColLg]="7" [lgCol]="12" class="footer__left-content">
      @if (primaryLinks || footerData?.includeCookiePolicyLink) {
        <ul class="footer__nav">
          @if (footerData?.includeCookiePolicyLink) {
            <li class="footer__nav-item">
              <span
                (click)="interactionClickEvent('', 'Cookie policy')"
                (keyup.enter)="
                  interactionClickEvent('', 'Cookie policy');
                  openCookiePreferences()
                "
                class="footer__nav-link ot-sdk-show-settings"
                tabindex="0"
                >{{ footerData?.cookiePolicyLinkText }}</span
              >
            </li>
          }

          @if (primaryLinks) {
            @for (link of primaryLinks; let i = $index; track i) {
              <li class="footer__nav-item">
                <dotcom-frontend-link
                  (click)="interactionClickEvent(link.href, link.text)"
                  [url]="link.href"
                  linkClass="footer__nav-link"
                  target="_blank"
                >
                  {{ link.text }}
                </dotcom-frontend-link>
              </li>
            }
          }
        </ul>
      }
      <p class="footer__copyright">{{ copyrightText }}</p>
    </div>

    <div [lgColLg]="5" [lgCol]="12" class="footer__right-content">
      <div class="footer__logo">
        @if (displayLogo) {
          <dotcom-frontend-link
            (click)="interactionClickEvent(logoUrl || '', 'logo-link')"
            [url]="logoUrl || ''"
            linkClass="footer__logo-link"
            target="_blank"
          >
            <img
              [alt]="logoAltText"
              [src]="logoImage"
              class="footer__logo-image"
              layout="fill"
            />
          </dotcom-frontend-link>
        }
      </div>

      @if (socialLinks) {
        <div class="footer__social-media">
          <ul class="footer__social-list">
            @for (socialLink of socialLinks; let i = $index; track i) {
              <li>
                <dotcom-frontend-link
                  [arialabel]="socialLink.text"
                  [title]="socialLink.text"
                  [url]="socialLink.href"
                  class="footer__social-link"
                  target="_blank"
                >
                  @if (socialLink.icon) {
                    <lg-icon
                      [name]="socialLink.icon.selector"
                      class="footer__social-icon"
                    />
                  }
                </dotcom-frontend-link>
              </li>
            }
          </ul>
        </div>
      }
    </div>
  </div>
</div>
